export const TYPE_DISTRICT = "d";
export const TYPE_CITY = "c";
export const TYPE_REGION = "r";
export const TYPE_COUNTRY = "l";
export const TYPE_TOURISTIC_REGION = "t";
